import { NgFor, NgIf } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { UserSupplierService } from '../../../../Services/User/Supplier/user-supplier.service';
import { NotificationService } from '../../../../Services/notification.service';
import { AuthService } from '../../../../Services/auth.service';

@Component({
  selector: 'app-kalakar-list',
  imports: [RouterLink, NgFor, NgIf],
  templateUrl: './kalakar-list.component.html',
  styleUrl: './kalakar-list.component.css',
})
export class KalakarListComponent implements OnInit {
  @Output() viewKalakarProfile = new EventEmitter<number>();

  userSupplierList: any[] = [];
  kalakar: any;
   role: string | null = null;

  constructor(
    private userSupplierService: UserSupplierService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {}

  private router = inject(Router);

  ngOnInit(): void {
    this.getUserSuppliers();
    this.getUserRole();
  }

   getUserRole() {
    this.role = this.authService.getUserRole(); // example: 'Admin', 'Owner', 'User'
    console.log('Current user role:', this.role);
  }


  getUserSuppliers() {
    const queryParams = new HttpParams()
      .append('user_supplier_type[]', 'Kalakar')
      .append('user_supplier_type[]', 'Karigar');
    this.userSupplierService.getUserSupplier(queryParams).subscribe({
      next: (res: any) => {
        this.userSupplierList = res.data;

        if (this.userSupplierList.length > 0) {
          localStorage.setItem(
            'supplierId',
            this.userSupplierList[0].id.toString()
          );
        }
      },
      error: (err: any) => {
        console.error('Error fetching user supplier list:', err);
      },
    });
  }

  onDelete(id: number) {
    this.userSupplierService.deleteUserSupplier(id).subscribe({
      next: (res: any) => {
        console.log('User Supplier Deleted Successfully:');
        this.notificationService.showSuccess(
          'Stone Deleted Successfully',
          'Success'
        );
        this.getUserSuppliers();
      },
      error: (err: any) => {
        console.error('Error deleting user supplier:', err);
      },
    });
  }

  // onKalakaeClick(id: number) {
  //   if (id) {
  //     localStorage.setItem('supplierId', id.toString());
  //     this.router.navigate(['/kalakaar-management/home']);
  //   }

onKalakaeClick(id: number) {
  const role = this.authService.getUserRole();
  localStorage.setItem('supplierId', id.toString());

  if (role === 'Owner') {
    this.router.navigate(['/admin-panel/admin-kalakar'], {
      queryParams: { id }
    });
  } else {
    this.router.navigate(['/kalakaar-management/home']);
  }
}

    goToKalakarProfile(kalakar: any) {
      this.router.navigate(['/admin-panel/admin-kalakar'], {
        queryParams: {
          id: kalakar.supplier_id,
          role: 'admin',
        },
      });
    }

      // openKalakarDetail(kalakar: any, event: Event) {
      //   event.stopPropagation();

      //   const supplierId = kalakar.supplier_id ?? kalakar.id;
      //   console.log('Selected Supplier ID:', supplierId);

      //   this.viewKalakarProfile.emit(supplierId);
      // }

    openKalakarDetail(kalakar: any, event: Event) {
    event.stopPropagation();

    const supplierId = kalakar.supplier_id ?? kalakar.id;
    localStorage.setItem('supplierId', supplierId.toString());

    if (this.role === 'Owner') {
      // 🔹 Owner — stay in current module and show inline profile
      this.viewKalakarProfile.emit(supplierId);
    } else if (this.role === 'Admin') {
      // 🔹 Admin — open Admin Kalakar inside Admin Panel layout
      this.router.navigate(['/admin-panel/admin-kalakar'], {
        queryParams: { id: supplierId, role: 'admin' },
      });
    } else {
      // 🔹 Other roles (like Kalakar or Staff)
      this.router.navigate(['/kalakaar-management/home']);
    }
  }

}
